import { useContext } from "react";
import {
  Body,
  Button,
  ButtonGroup,
  LandingContaner,
  LogoImg,
  Text,
  Title,
} from "./LocalStyle";
import { GlobalContext } from "global/context/Provider";
import { useHistory } from "react-router";

const Landing = () => {
  // -------------------------  context ----------------------------
  const { configState } = useContext(GlobalContext);
  const history = useHistory();
  // -------------------------  context ----------------------------

  // -------------------------  constantes ----------------------------
  const androidURL = configState?.config?.data?.urlPlayStore;
  const iosURL = configState?.config?.data?.urlAppStore;
  // -------------------------  constantes ----------------------------

  // -------------------------  useEffects  ----------------------------

  //  -------------------------  useEffects  ----------------------------

  // -------------------------  funciones  ----------------------------
  const continueWeb = () => {
    history.push("/");
  };

  const openAppOrStore = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    const androidIntent =
      "intent://tuapp.com/open#Intent;scheme=https;package=ar.com.dim.portalturnos;end";
    const androidStore = androidURL;
    const iosStore = iosURL;

    if (/android/i.test(userAgent)) {
      window.location.href = androidIntent;
      setTimeout(() => {
        window.location.href = androidStore;
      }, 1000);
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      window.location.href = "tuapp://open";
      setTimeout(() => {
        window.location.href = iosStore;
      }, 1000);
    } else {
      alert("Esta función está disponible solo en dispositivos móviles.");
    }
  };

  // -------------------------  funciones ----------------------------

  return (
    <LandingContaner>
      <Body>
        <LogoImg
          src={process.env.PUBLIC_URL + "/assets/images/empresa/IsoLogo.png"}
          alt="Logo"
        />
        <Title className="c-white">
          ¿Sabías que también podés recepcionar tus turnos desde nuestra app?
        </Title>
        <Text className="c-white">
          Con nuestra app podés gestionar tus turnos más rápido, ver tus
          resultados y acceder estés donde estés. ¡Descargala gratis!
        </Text>
        <ButtonGroup>
          <Button onClick={continueWeb}>Continuar en la web</Button>
          <Button onClick={openAppOrStore}>Abrir app</Button>
        </ButtonGroup>
      </Body>
    </LandingContaner>
  );
};

export default Landing;
